import React from "react";
import RequestUtil from "../utils/RequestUtil"
import {clearWhitespace, isEndWithQuestionMark} from "../utils/TextUtil"

import "animate.css/animate.css";

import ImgModal from "./ImageModal";

const YES_NO_API_ENDPOINT = "https://yesno.wtf/api";
const STORE_API_ENDPOINT = "https://us-central1-myproduction-d6199.cloudfunctions.net/askMeYesNoQuestion";

export default class YesNo extends React.Component {
  constructor(props) {
    super(props);
    this.requestUtil = new RequestUtil()
    this.state = {
      elementsState: {
        isGameStarted: false,
        isShowInputNameBox: true,
        isSubmiting: false,
        isSubmitable: false,
      },
      emojiUsed: { emoji: "😎", desc: "Emoji wear sunglasses smiled" },
      emojiOnInit: { emoji: "😎", desc: "Emoji wear sunglasses smiled" },
      emojiOnHover: { emoji: "😍", desc: "Emoji smile with feeling love" },
      playerName: "",
      gameState: {
        question: "",
        statusText: "I can't give you an answer until you ask a question.",
        typingTimeout: null,
      },
      gameResult: {
        image: "",
        answer: "",
      },
    };
  }

  handleEmojiOnButton = (isHover) => {
    let usedEmoji = isHover? this.state.emojiOnHover : this.state.emojiOnInit
    setTimeout(() => {
      this.setState({
        emojiUsed: usedEmoji
      });
    }, 100);
  };

  handleStartGame = () => {
    this.setState({elementsState: {...this.state.elementsState, isGameStarted: true}});
  };

  handleEnterName = () => {
    let playerName = clearWhitespace(this.refs.playerName.value);
    if (playerName) {
      const currentState = {...this.state}
      currentState.elementsState.isShowInputNameBox = false
      currentState.playerName = playerName
      this.setState(currentState);
    }
  }

  handleTyping = (event) => {
    clearTimeout(this.state.gameState.typingTimeout);
    let question = event.target.value;
    const currentState = {...this.state};
    currentState.gameState.statusText = "Waiting for you stop typing...";
    currentState.gameState.question = question
    currentState.gameState.typingTimeout = setTimeout(() => {
      this.validateQuestion(question);
    }, 500);
    this.setState(currentState);
  };

  validateQuestion = (question) => {
    const currentState = {...this.state};
    let cleanedQuestion = clearWhitespace(question)
    let isSubmitable = false;
    let statusText = "I can't give you an answer until you ask a question.";
    if (cleanedQuestion && cleanedQuestion !== "?") {
      let validQuestion = isEndWithQuestionMark(cleanedQuestion)
      if (validQuestion) {
        isSubmitable = true
        statusText = "Click button 👇";
      } else {
        statusText = "A question must be contain '?'.";
      }
    }
    currentState.elementsState.isSubmitable = isSubmitable;
    currentState.gameState.statusText = statusText;
    this.setState(currentState);
  }

   fetchAns = async () => {
    const blackList = [
      "https://yesno.wtf/assets/yes/6-304e564038051dab8a5aa43156cdc20d.gif",
      "https://yesno.wtf/assets/no/3-80a6f5b5d6684674bcfeda34accca4e1.gif"
    ];
    let result = await this.requestUtil.get(YES_NO_API_ENDPOINT, "/")
    let shouldRecall = Boolean(blackList.find((image) => image === result.image));
    if (shouldRecall) {
      return await this.fetchAns();
    } else {
      return result;
    }
  }

  storeResult = (answer) => {
    let payload = {
      date: new Date().toJSON(),
      sender_name: this.state.playerName,
      question: this.state.gameState.question,
      answer
    }
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Access-Control-Allow-Methods": "POST, GET, PUT, PATCH, DELETE, OPTIONS"
    }
    this.requestUtil.post(STORE_API_ENDPOINT,"/",headers,payload)
  }

  setAnswer = (answer) => {
    const currentState = {...this.state}
    currentState.gameState = {
      question: "",
      statusText: "I can't give you an answer until you ask a question.",
      typingTimeout: null,
    }
    currentState.gameResult = answer
    currentState.elementsState.isSubmiting = false
    currentState.elementsState.isSubmitable = false
    this.setState(currentState);
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const currentState = {...this.state};
    if (this.state.elementsState.isSubmitable) {
      currentState.elementsState.isSubmiting = true
      currentState.gameResult = {image: "", answer: ""};
      currentState.gameState.statusText = "I'm thinking...";
      this.setState(currentState);
      let fetchResult = await this.fetchAns();
      const answer = {image: fetchResult.data.image, answer: fetchResult.data.answer}
      this.setAnswer(answer)
      this.storeResult(answer)
    } else if (!this.state.gameState.question) {
      currentState.gameState.statusText = "Question is required 😂";
      this.setState(currentState);
    }
  }

  render() {
    let overlayStyle = {
      pointerEvents: "none",
      filter: "blur(.5rem)"
    };
    return (
      <div>
        { !this.state.elementsState.isGameStarted &&
          <div className="field has-text-centered" id="field">
            <button
              className="button button-float is-large"
              onPointerEnter={()=> {this.handleEmojiOnButton(true)}}
              onPointerLeave={()=> {this.handleEmojiOnButton(false)}}
              onClick={this.handleStartGame}
            >
              Click me{" "}
              <span
                className="icon-is-left"
                role="img"
                aria-label={this.state.emojiUsed.desc}
              >
                {this.state.emojiUsed.emoji}
              </span>
            </button>
          </div>
        }

        { this.state.elementsState.isGameStarted &&
          <div className="box animated flipInY">
            <div style={this.state.playerName ? {} : overlayStyle}>
              <h1 className="subtitle subtitle-is-help">
                Hi, {this.state.playerName}.
              </h1>
              <h1 className="title is-2">Ask me!</h1>
              <h1 className="subtitle subtitle-is-help">a yes-no question</h1>
              <form onSubmit={this.handleSubmit}>
                <div className="field">
                  <input
                    className="input"
                    type="text"
                    value={this.state.gameState.question}
                    onChange={this.handleTyping}
                  />
                  <h1 className="help">{this.state.gameState.statusText}</h1>
                </div>
                <div
                  className="field has-text-centered"
                  style={{ marginTop: "30px" }}
                >
                  <button className={`button ${this.state.elementsState.isSubmiting ? "is-loading" : ""}`} ref="btnSubmitQuestion">
                    Gentle click
                  </button>
                </div>
              </form>
            </div>
              { this.state.elementsState.isShowInputNameBox &&
                <div className="wrapper is-overlay-x" ref="inputName">
                  <div className="control has-text-centered">
                    <span>Enter your name: </span>
                    <input
                      className="input"
                      ref="playerName"
                      style={{ width: "150px" }}
                      type="text"
                    />
                    <button
                      className="button is-small"
                      onClick={this.handleEnterName}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              }
          </div>
        }
        <ImgModal
          image={this.state.gameResult.image}
          answer={this.state.gameResult.answer}
        />
      </div>
    );
  }
}
